import { effect, Injectable, signal } from '@angular/core';
import { environmnent } from '@environments/environment';

export type AppTheme = 'dark' | 'light';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly _isHml = signal(!environmnent.production);
  readonly currentTheme = signal<AppTheme>(this.getInitialTheme());

  constructor() {
    effect(() => {
      if (this._isHml()) {
        document.body.classList.add('hml-theme');
      } else {
        document.body.classList.remove('hml-theme');
      }
    });

    effect(() => {
      const theme = this.currentTheme();
      document.body.classList.remove('dark', 'light');
      document.body.classList.add(theme);
      document.documentElement.setAttribute('theme', theme);
      try {
        localStorage.setItem('sales_theme', theme);
      } catch {
        // Safe fallback if localStorage is disabled
      }
    });
  }

  isHml() {
    return this._isHml();
  }

  toggleHmlTheme() {
    this._isHml.set(!this._isHml());
  }

  isDarkMode() {
    return this.currentTheme() === 'dark';
  }

  toggleTheme() {
    this.currentTheme.update(t => t === 'dark' ? 'light' : 'dark');
  }

  setTheme(theme: AppTheme) {
    this.currentTheme.set(theme);
  }

  private getInitialTheme(): AppTheme {
    try {
      const saved = localStorage.getItem('sales_theme') as AppTheme | null;
      if (saved === 'dark' || saved === 'light') {
        return saved;
      }
    } catch {
      // Ignore localStorage read errors
    }
    return 'dark'; // Default to executive Obsidian & Gold
  }
}
